"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Tree = _interopRequireDefault(require("@rsuite/icon-font/lib/file/Tree"));

// Generated by script, don't edit it please.
var Tree = (0, _createSvgIcon["default"])({
  as: _Tree["default"],
  ariaLabel: 'tree',
  category: 'file',
  displayName: 'Tree'
});
var _default = Tree;
exports["default"] = _default;
module.exports = exports.default;